"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "@/components/ui/Link";
import { MessageIcon } from "../ui/message-icon";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};
type Props = {
  title?: FieldConfig;
  timeAgo?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
  priority?: boolean;
  imageMetadata?: ImageMetadata;
};
export default function HorizontalSmallImageNews(t0) {
  const $ = _c(25);
  const {
    title: t1,
    timeAgo: t2,
    imageSrc: t3,
    slug,
    priority: t4,
    imageMetadata
  } = t0;
  let t5;
  if ($[0] !== t1) {
    t5 = t1 === undefined ? {
      hidden: false,
      value: "\u0B9F\u0BC6\u0BB2\u0BCD\u0BB2\u0BBF \u0BB5\u0BC6\u0BB3\u0BCD\u0BB3\u0BAE\u0BCD: \u0BAF\u0BAE\u0BC1\u0BA9\u0BBE \u0BA8\u0BA4\u0BBF 40 \u0BB5\u0BB0\u0BC1\u0B9F \u0B9A\u0BBE\u0BA4\u0BA9\u0BC8\u0BAF\u0BBF\u0BB2\u0BCD 207 M \u0B8E\u0BA9\u0BCD\u0BB1 \u0BAE\u0BBF\u0B95 \u0B89\u0BAF\u0BB0\u0BCD\u0BA8\u0BCD\u0BA4 \u0B85\u0BB3\u0BB5\u0BC8 \u0B8E\u0B9F\u0BCD\u0B9F\u0BBF\u0BAF\u0BA4\u0BC1",
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const title = t5;
  t2 === undefined ? {
    hidden: false,
    value: "15 min ago",
    customClass: ""
  } : t2;
  let t6;
  if ($[2] !== t3) {
    t6 = t3 === undefined ? {
      hidden: false,
      value: FALLBACK_IMAGE,
      customClass: ""
    } : t3;
    $[2] = t3;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const imageSrc = t6;
  const priority = t4 === undefined ? false : t4;
  const titleValue = title?.value || "";
  let t7;
  if ($[4] !== imageSrc?.value) {
    t7 = getImageUrl(imageSrc?.value) || FALLBACK_IMAGE;
    $[4] = imageSrc?.value;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  const imageSrcValue = t7;
  let t8;
  if ($[6] !== imageMetadata || $[7] !== imageSrc?.customClass || $[8] !== imageSrc?.hidden || $[9] !== imageSrcValue || $[10] !== priority || $[11] !== titleValue) {
    t8 = !imageSrc?.hidden && <div className={`relative w-[88px] h-[88px] flex-shrink-0 overflow-hidden ${imageSrc?.customClass || ""}`}><Image src={imageSrcValue} alt={titleValue} width={88} height={88} className="w-full h-full object-cover" style={getFocusPointStyle(imageMetadata)} loading={priority ? "eager" : "lazy"} fetchPriority={priority ? "high" : "auto"} priority={priority} placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} /></div>;
    $[6] = imageMetadata;
    $[7] = imageSrc?.customClass;
    $[8] = imageSrc?.hidden;
    $[9] = imageSrcValue;
    $[10] = priority;
    $[11] = titleValue;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== title?.customClass || $[14] !== title?.hidden || $[15] !== titleValue) {
    t9 = !title?.hidden && <h3 className={`text-16-tamil-400 text-4D4D4D font-medium leading-[1.5] ${title?.customClass || ""}`}>{titleValue}</h3>;
    $[13] = title?.customClass;
    $[14] = title?.hidden;
    $[15] = titleValue;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t9) {
    t10 = <div className="flex flex-col justify-center w-full">{t9}</div>;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t8) {
    t11 = <article className="p-4"><div className="flex gap-3">{t8}{t10}</div></article>;
    $[19] = t10;
    $[20] = t8;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  const content = t11;
  if (slug) {
    const t12 = `/${slug}`;
    let t13;
    if ($[22] !== content || $[23] !== t12) {
      t13 = <Link href={t12} className="block  transition-colors cursor-pointer">{content}</Link>;
      $[22] = content;
      $[23] = t12;
      $[24] = t13;
    } else {
      t13 = $[24];
    }
    return t13;
  }
  return content;
}